/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class PassBottomNav extends PureComponent {
    static propTypes = {
        proceedButton: PropTypes.node.isRequired,
    };

    render() {
        const { proceedButton } = this.props;

        return (
            <div className="activitypass-bottom-nav">
                <div className="proceed-button">{proceedButton}</div>
            </div>
        );
    }
}

// cspell:ignore activitypass
